module.exports = __webpack_public_path__ + "dropify.b321d818cc153b16e739.svg";


//////////////////
// WEBPACK FOOTER
// /home/arine/CC2/node_modules/dropify/dist/fonts/dropify.svg
// module id = ../../../../dropify/dist/fonts/dropify.svg
// module chunks = styles